// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"s0-z","subtitle":"t0-z","wrapper":"u0-z","leftArrow":"v0-z","rightArrow":"w0-z"};